export default "__VITE_ASSET__DK3lxx8v__"